import React from 'react';
/**
 * DjayIdentity — "this is YOU". Renders Djay as the learner's CURRENT look.
 *
 * Automatically mirrors useDjayLook() (variant + accessory + tier). Call-sites
 * CANNOT pass a partial look — that is the whole point: an Identity surface can
 * never again drop the accessory or tier the way Sidebar / practice-feedback did.
 *
 * Use this everywhere Djay represents the learner: sidebar, home hero,
 * practice feedback, progress trailhead, collection hero, floating buddy, prompts.
 *
 * See docs/audits/MASCOT_SSOT_ARCHITECTURE_AUDIT_2026.md §5.2 (intent A).
 */
import { DjayAvatar } from './DjayAvatar';
import type { DjayAvatarProps } from './DjayAvatar';
import { useDjayLook } from './useDjayLook';
// Identity surfaces choose only DISPLAY props; the look comes from the SSOT.
export type DjayIdentityProps = Omit<DjayAvatarProps, 'variant' | 'accessory' | 'tier'>;
export function DjayIdentity(props: DjayIdentityProps) {
  const look = useDjayLook();
  return <DjayAvatar variant={look.variant} accessory={look.accessory} tier={look.tier} {...props} data-id="element-3260" />;
}